import deepmerge from 'deepmerge';

export const defaultFocusable = {
  outlineStyle: 'dotted',
  outlineOffset: -1,
  outlineWidth: 2
}

const createOptions = ({
  blue400
}: any) => {
  const focusedBorder = {
    outlineColor: blue400,
    ...defaultFocusable
  };
  return {
    touch: focusedBorder,
    low: focusedBorder,
    medium: focusedBorder,
    high: focusedBorder
  };
};

const createGetFocusable = (options: any) => (density = 'medium') => options(density);

export const createFocusable = (palette: any, focusable = {}) => {
  const { getFocusable: otherGetFocusable, ...otherOptions }
      = typeof focusable == 'function' ? focusable(palette) : focusable;
  const options = createOptions(palette);
  const mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return {
    getFocusable: otherGetFocusable || createGetFocusable(mergedOptions),
    ...mergedOptions
  };
};
